import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-navy-950 relative overflow-hidden" data-id="element-47">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_bottom,_var(--tw-gradient-stops))] from-gold-900/20 via-navy-950 to-navy-950 pointer-events-none" data-id="element-48" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-49">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-50">
          <h2 className="text-4xl font-bold text-white mb-12" data-id="element-51">
            El Próximo Paso Es Tuyo
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16 text-left" data-id="element-52">
            <div className="bg-navy-900/50 border border-white/5 p-8 rounded-2xl opacity-70" data-id="element-53">
              <h3 className="text-xl font-bold text-slate-400 mb-4" data-id="element-54">
                Opción A:
              </h3>
              <p className="text-slate-400" data-id="element-55">
                Seguir haciendo lo mismo. Más cursos sueltos, más consejos
                genéricos, más meses sin resultados.
              </p>
            </div>

            <div className="bg-navy-800 border border-gold-500/40 p-8 rounded-2xl box-glow relative" data-id="element-56">
              <div className="absolute -top-3 -right-3 w-6 h-6 bg-gold-500 rounded-full animate-pulse" data-id="element-57" />
              <h3 className="text-xl font-bold text-gold-400 mb-4" data-id="element-58">
                Opción B:
              </h3>
              <p className="text-white font-medium" data-id="element-59">
                Obtener el sistema completo hoy. Empezar a ejecutar mañana.
              </p>
            </div>
          </div>

          <motion.div whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="inline-block w-full sm:w-auto" data-id="element-60">
            <button className="w-full sm:w-auto px-10 py-6 bg-gradient-to-r from-gold-500 to-gold-400 hover:from-gold-400 hover:to-gold-300 text-navy-950 font-black text-xl sm:text-2xl rounded-xl shadow-[0_0_30px_rgba(212,175,55,0.5)] hover:shadow-[0_0_50px_rgba(212,175,55,0.7)] transition-all duration-300 flex items-center justify-center space-x-3 group" data-id="element-61">
              <span data-id="element-62">SÍ, QUIERO EL SISTEMA COMPLETO</span>
              <ArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-63" />
            </button>
          </motion.div>

          <p className="mt-6 text-slate-400 max-w-2xl mx-auto" data-id="element-64">
            Accede ahora a "Secretos de Promoción" y empieza a construir el
            negocio de afiliados que llevas meses intentando levantar
          </p>
        </motion.div>
      </div>
    </section>;
}